import { useQuery } from '@tanstack/react-query'
import { PlaylistDetailsType } from 'sdk/types.d';
import { PostgrestSingleResponse } from '@supabase/supabase-js'
import { supabase } from '../api'

const getPlaylist = async (id: number | string): Promise<any> => {
  const { data, error }: PostgrestSingleResponse<PlaylistDetailsType> = await supabase
    .from('playlists')
    .select(`
      *,
      items:posts (
        *,
        profile:user_profiles (id, username),
        assets:assets!posts_assets (*)
      )
    `)
    .eq('id', id)
    .single()

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export default function usePlaylist(id: number | string) {
  return useQuery({
    queryKey: ['playlist', id],
    queryFn: () => getPlaylist(id),
    staleTime: 60000,
    enabled: !!id,
  })
}
